/**
 * ShadowControl - Shadow settings panel
 * Adapted from shadcn-studio
 */

import { SliderWithInput } from "./slider-with-input";
import { ColorSwatch } from "./color-swatch";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface ShadowControlProps {
  shadowColor: string;
  shadowOpacity: number;
  shadowBlur: number;
  shadowSpread: number;
  shadowOffsetX: number;
  shadowOffsetY: number;
  onChange: (key: string, value: string | number) => void;
}

export function ShadowControl({
  shadowColor,
  shadowOpacity,
  shadowBlur,
  shadowSpread,
  shadowOffsetX,
  shadowOffsetY,
  onChange,
}: ShadowControlProps) {
  return (
    <Accordion type="single" defaultValue="shadow" collapsible>
      <AccordionItem value="shadow" className="rounded-lg border border-border px-4">
        <AccordionTrigger className="cursor-pointer py-3 text-sm font-medium">
          Shadow
        </AccordionTrigger>
        <AccordionContent className="space-y-3 pt-2 pb-4">
          <div className="space-y-4">
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium">Shadow Color</span>
              </div>
              <ColorSwatch
                color={shadowColor}
                index={0}
                onChange={(_index, color) => onChange("shadow-color", color)}
              />
            </div>

            <div>
              <SliderWithInput
                value={shadowOpacity}
                onChange={(value) => onChange("shadow-opacity", value)}
                min={0}
                max={1}
                step={0.01}
                unit=""
                label="Shadow Opacity"
              />
            </div>

            <div>
              <SliderWithInput
                value={shadowBlur}
                onChange={(value) => onChange("shadow-blur", value)}
                min={0}
                max={50}
                step={0.5}
                unit="px"
                label="Blur Radius"
              />
            </div>

            <div>
              <SliderWithInput
                value={shadowSpread}
                onChange={(value) => onChange("shadow-spread", value)}
                min={-50}
                max={50}
                step={0.5}
                unit="px"
                label="Spread"
              />
            </div>

            <div>
              <SliderWithInput
                value={shadowOffsetX}
                onChange={(value) => onChange("shadow-offset-x", value)}
                min={-50}
                max={50}
                step={0.5}
                unit="px"
                label="Offset X"
              />
            </div>

            <div>
              <SliderWithInput
                value={shadowOffsetY}
                onChange={(value) => onChange("shadow-offset-y", value)}
                min={-50}
                max={50}
                step={0.5}
                unit="px"
                label="Offset Y"
              />
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
